import Button from "components/atoms/Button";
import InputCheckbox from "components/atoms/InputCheckbox";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  LabCheckingOptions,
  OperatorOptions,
  PageMode,
  RegmalCaseFromOptions,
  YesAndNoOptions,
} from "utils/constant";
const DiscoveryStatusStepForm = ({
  onPrevStep,
  onNextStep,
  cadresData,
  srData,
  ssrData,
  mbsDates,
  surveyContactCases,
  formik,
  getSurveyContacts,
  pageMode,
  isNotifikasiBKK,
}) => {
  const { currentUser } = useSelector((state) => state.authReducer);
  const isBKKUser =
    currentUser.level === "BKKWilker" || currentUser.level === "BKKInduk";
  const [isEdit, setisEdit] = useState(
    pageMode === PageMode.edit && isNotifikasiBKK,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    const value = e.target.value;

    const current = Array.isArray(formik.values.parasyte)
      ? formik.values.parasyte
      : [];

    let newValues;
    if (value === "P.Mix") {
      newValues = isChecked ? ["P.Mix"] : [];
    } else {
      newValues = isChecked
        ? [...current, value]
        : current.filter((item) => item !== value);
    }
    formik.setFieldValue("parasyte", newValues);

    // "Kekambuhan" (recurrence) wajib diisi backend; hanya dikosongkan bila
    // pilihan "Relaps" tidak lagi relevan, bukan setiap kali parasit berubah.
    const relapsEligible =
      newValues.includes("P.Ovale") ||
      newValues.includes("P.Vivax") ||
      newValues.includes("P.Mix");

    if (!relapsEligible && formik.values.recurrence === "Relaps") {
      formik.setFieldValue("recurrence", null);
      formik.setFieldValue("g6pd", "");
      formik.setFieldValue("g6pd_result", "");
    }
  };

  const discoveryActivitiesOpt = () => {
    if (isBKKUser) {
      return [
        {
          label: "Pasif",
          options: [{ value: "PCD", label: "PCD" }],
        },
        {
          label: "Aktif",
          options: [
            {
              value: "Surveilans Migrasi",
              label: "Surveilans Migrasi malaria (BKK)",
            },
          ],
        },
      ];
    }

    const { values } = formik;

    // --- Constants for common options ---
    const COMMON_PASSIVE_OPTIONS = [
      { value: "PCD", label: "PCD" },
      { value: "FUP", label: "FUP" },
    ];

    const ALWAYS_ACTIVE_OPTIONS = [
      {
        value: "Active Fever Screening (AFS)",
        label: "Active Fever Screening (AFS)",
      },
      {
        value: "Cek Kesehatan Gratis (CKG)",
        label: "Cek Kesehatan Gratis (CKG)",
      },
      { value: "EDAT", label: "EDAT" },
    ];

    const BASE_ACTIVE_OPTIONS = [
      { value: "Kunjungan Rumah", label: "Kunjungan Rumah" },
      { value: "Survei Non PE", label: "Survei Non PE" },
    ];

    const GENERAL_ACTIVE_OPTIONS = [
      ...BASE_ACTIVE_OPTIONS,
      { value: "MBS", label: "MBS" },
      { value: "Survei Kontak", label: "Survei Kontak" },
      { value: "Surveilans Migrasi", label: "Surveilans Migrasi" },
      { value: "Pusling", label: "Pusling" },
      { value: "Posyandu", label: "Posyandu" },
    ];

    // --- Helper functions for conditions ---
    const isChild = () =>
      (values.age < 5 && values.age_type === "Tahun") ||
      (values.age < 12 && values.age_type === "Bulan");

    const isPregnant = () => values.pregnancy === "Hamil";
    const isFromPerdhakiKlinik = () => values.case_from === "Perdhaki";

    let passiveOptions = [];
    let activeOptions = [];

    if (isFromPerdhakiKlinik()) {
      // Perdhaki specific logic
      if (isChild()) {
        passiveOptions = [
          ...COMMON_PASSIVE_OPTIONS,
          { value: "MBS", label: "MBS" },
          {
            value: "Skrining Balita Sakit/MTBS",
            label: "Skrining Balita Sakit/MTBS",
          },
        ];
        activeOptions = [...BASE_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      } else if (isPregnant()) {
        passiveOptions = [
          ...COMMON_PASSIVE_OPTIONS,
          { value: "MBS", label: "MBS" },
          { value: "Skrining Bumil", label: "Skrining Bumil" },
        ];
        activeOptions = [...BASE_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      } else {
        passiveOptions = [
          { value: "PCD", label: "PCD" },
          { value: "MBS", label: "MBS" },
        ];
        activeOptions = [...BASE_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      }
    } else {
      // General logic for other clinics/cases
      if (isChild() && isPregnant()) {
        passiveOptions = [
          ...COMMON_PASSIVE_OPTIONS,
          {
            value: "Skrining Balita Sakit/MTBS",
            label: "Skrining Balita Sakit/MTBS",
          },
          { value: "Skrining Bumil", label: "Skrining Bumil" },
        ];
        activeOptions = [...GENERAL_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      } else if (isChild()) {
        passiveOptions = [
          ...COMMON_PASSIVE_OPTIONS,
          {
            value: "Skrining Balita Sakit/MTBS",
            label: "Skrining Balita Sakit/MTBS",
          },
        ];
        activeOptions = [...GENERAL_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      } else if (isPregnant()) {
        passiveOptions = [
          ...COMMON_PASSIVE_OPTIONS,
          { value: "Skrining Bumil", label: "Skrining Bumil" },
        ];
        activeOptions = [...GENERAL_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      } else {
        passiveOptions = COMMON_PASSIVE_OPTIONS;
        activeOptions = [...GENERAL_ACTIVE_OPTIONS, ...ALWAYS_ACTIVE_OPTIONS];
      }
    }

    return [
      { label: "Pasif", options: passiveOptions },
      { label: "Aktif", options: activeOptions },
    ];
  };

  const discoveryActivitiesOptNonPKM = () => {
    if (isBKKUser) {
      return [
        {
          label: "Pasif",
          options: [{ value: "PCD", label: "PCD" }],
        },
        {
          label: "Aktif",
          options: [
            {
              value: "Surveilans Migrasi",
              label: "Surveilans Migrasi malaria (BKK)",
            },
          ],
        },
      ];
    }
    if (formik.values.age < 5) {
      return [
        {
          label: "Pasif",
          options: [
            { value: "PCD", label: "PCD" },
            {
              value: "Skrining Balita Sakit/MTBS",
              label: "Skrining Balita Sakit/MTBS",
            },
            { value: "FUP", label: "FUP" },
          ],
        },
      ];
    } else if (formik.values.pregnancy === "Hamil") {
      return [
        {
          label: "Pasif",
          options: [
            { value: "PCD", label: "PCD" },
            { value: "Skrining Bumil", label: "Skrining Bumil" },
            { value: "FUP", label: "FUP" },
          ],
        },
      ];
    } else {
      return [
        {
          label: "Pasif",
          options: [
            { value: "PCD", label: "PCD" },
            { value: "FUP", label: "FUP" },
          ],
        },
      ];
    }
  };

  const discoveryActivitiesValue = formik.values.discovery_activities;

  let selectedDiscovertActivty = "";

  if (currentUser?.fasyankes_type_id === "jnsfas-01") {
    const mathingOption = discoveryActivitiesOpt().find((item) => {
      return item.options.some(
        (option) => option.value === discoveryActivitiesValue,
      );
    });
    selectedDiscovertActivty = mathingOption?.options?.find(
      (item) => item.value === discoveryActivitiesValue,
    );
  } else {
    const mathingOption = discoveryActivitiesOptNonPKM().find((item) => {
      return item.options.some(
        (option) => option.value === discoveryActivitiesValue,
      );
    });
    selectedDiscovertActivty = mathingOption?.options?.find(
      (item) => item.value === discoveryActivitiesValue,
    );
  }

  const renderOperatorFieldByCondition = () => {
    if (
      formik.values.discovery_activities === "MBS" ||
      formik.values.discovery_activities === "Survei Kontak" ||
      formik.values.discovery_activities === "Survei Non PE" ||
      formik.values.discovery_activities === "Kunjungan Rumah" ||
      formik.values.discovery_activities === "Surveilans Migrasi" ||
      formik.values.discovery_activities === "Skrining Bumil" ||
      formik.values.discovery_activities === "MTBS" ||
      formik.values.discovery_activities === "FUP" ||
      formik.values.discovery_activities === "Posyandu" ||
      formik.values.discovery_activities === "EDAT" ||
      formik.values.discovery_activities === "Active Fever Screening (AFS)"
    ) {
      return (
        <InputSelect
          label={"Petugas"}
          name={"house_visit"}
          placeholder={"Pilih Petugas"}
          data={OperatorOptions}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            if (selectedValue === "Nakes") {
              formik.handleChange("house_visit")(selectedValue);
              formik.setFieldValue("cadres_id", "");
              formik.setFieldValue("isCadre", "");
            } else if (selectedValue === "Kader") {
              formik.handleChange("house_visit")(selectedValue);
              formik.setFieldValue("isCadre", "Ya");
            }
          }}
          onBlur={formik.handleBlur}
          value={OperatorOptions?.find(
            (item) => item.value === formik.values.house_visit,
          )}
          error={formik.errors.house_visit && formik.touched.house_visit}
          errorMessage={formik.errors.house_visit}
          isRequired={true}
          disabled={isBKKUser && isEdit}
        />
      );
    }
  };

  const isButtonDisabled = () => {
    const isCaseFromEmpty =
      !formik.values.case_from ||
      (formik.values.case_from === "Lainnya" && !formik.values.other_case_from);

    const isDiscoveryActivitiesEmpty = !formik.values.discovery_activities;

    const isPatientVisitDateEmpty = !formik.values.patient_visite_date;

    const isLabCheckingTypeWithParasyte =
      formik.values.lab_checking_type === "Mikroskop" ||
      formik.values.lab_checking_type === "RDT";

    const isRegPatientEmpty =
      formik.values.lab_checking_type === "Mikroskop" &&
      formik.values.no_registrasi_pasien === "";

    const isParasyteEmpty =
      isLabCheckingTypeWithParasyte &&
      (!formik.values.parasyte ||
        formik.values.parasyte.length === 0 ||
        !formik.values.lab_checking_date);

    const isHouseVisitEmpty =
      formik.values.discovery_activities !== "PCD" &&
      formik.values.discovery_activities !== "Pusling" &&
      formik.values.discovery_activities !== "Skrining Balita Sakit/MTBS" &&
      formik.values.discovery_activities !== "Cek Kesehatan Gratis (CKG)" &&
      !formik.values.house_visit;

    const isCadreEmpty =
      formik.values.house_visit === "Kader" && !formik.values.isCadre;

    const isCadreIdEmpty =
      formik.values.isCadre === "Ya" && !formik.values.cadres_id?.length;

    const isSrEmpty =
      formik.values.case_from === "Perdhaki" && !formik.values.sr_id;
    const isSsrEmpty =
      formik.values.case_from === "Perdhaki" && !formik.values.ssr_id;

    if (currentUser?.fasyankes_type_id === "jnsfas-01") {
      return (
        isCaseFromEmpty ||
        isDiscoveryActivitiesEmpty ||
        isPatientVisitDateEmpty ||
        isParasyteEmpty ||
        isRegPatientEmpty ||
        isHouseVisitEmpty ||
        isCadreEmpty ||
        isCadreIdEmpty ||
        isSrEmpty ||
        isSsrEmpty
      );
    } else {
      return (
        isDiscoveryActivitiesEmpty ||
        isPatientVisitDateEmpty ||
        isParasyteEmpty ||
        isRegPatientEmpty ||
        isHouseVisitEmpty ||
        isCadreEmpty ||
        isCadreIdEmpty
      );
    }
  };

  return (
    <>
      <h3 className="subtitle-section">Asal penemuan Kasus</h3>
      {currentUser?.fasyankes_type_id === "jnsfas-01" && (
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"Asal Penemuan"}
              name={"case_from"}
              placeholder={"Pilih Asal Penemuan"}
              data={RegmalCaseFromOptions}
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                if (selectedValue) {
                  formik.handleChange("case_from")(selectedValue);
                  if (selectedValue !== "Perdhaki") {
                    formik.setFieldValue("sr_id", "");
                    formik.setFieldValue("ssr_id", "");
                  }
                  if (selectedValue !== "Lainnya") {
                    formik.setFieldValue("other_case_from", "");
                  }
                }
              }}
              onBlur={formik.handleBlur}
              value={RegmalCaseFromOptions?.find(
                (item) => item.value === formik.values.case_from,
              )}
              error={formik.errors.case_from && formik.touched.case_from}
              errorMessage={formik.errors.case_from}
              isRequired={true}
              disabled={isBKKUser && isEdit}
            />

            {formik.values.case_from === "Lainnya" && (
              <InputField
                name={"other_case_from"}
                placeholder={"Masukkan Asal Penemuan Lainnya"}
                {...formik.getFieldProps("other_case_from")}
                error={
                  formik.errors.other_case_from &&
                  formik.touched.other_case_from
                }
                errorMessage={formik.errors.other_case_from}
                disabled={isBKKUser && isEdit}
              />
            )}
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Kegiatan Penemuan"}
              name={"discovery_activities"}
              placeholder={"Pilih Kegiatan Penemuan"}
              data={discoveryActivitiesOpt()}
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                if (selectedValue) {
                  formik.handleChange("discovery_activities")(selectedValue);
                  if (
                    selectedValue === "PCD" ||
                    selectedValue === "Pusling" ||
                    selectedValue === "Cek Kesehatan Gratis (CKG)"
                  ) {
                    formik.setFieldValue("house_visit", "");
                    formik.setFieldValue("isCadre", "");
                    formik.setFieldValue("cadres_id", "");
                    formik.setFieldValue("mbs_date", "");
                    formik.setFieldValue("survey_contact_date", "");
                    formik.setFieldValue(
                      "first_case_trigger_survey_contact",
                      "",
                    );
                  }
                }
              }}
              onBlur={formik.handleBlur}
              value={selectedDiscovertActivty}
              error={
                formik.errors.discovery_activities &&
                formik.touched.discovery_activities
              }
              errorMessage={formik.errors.discovery_activities}
              isRequired={true}
              disabled={isBKKUser && isEdit}
            />
          </div>
        </div>
      )}
      {currentUser?.fasyankes_type_id !== "jnsfas-01" && (
        <InputSelect
          label={"Kegiatan Penemuan"}
          name={"discovery_activities"}
          placeholder={"Pilih Kegiatan Penemuan"}
          data={discoveryActivitiesOptNonPKM()}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            if (selectedValue) {
              formik.handleChange("discovery_activities")(selectedValue);
            }
          }}
          onBlur={formik.handleBlur}
          value={selectedDiscovertActivty}
          error={
            formik.errors.discovery_activities &&
            formik.touched.discovery_activities
          }
          errorMessage={formik.errors.discovery_activities}
          isRequired={true}
          disabled={isBKKUser && isEdit}
        />
      )}
      {formik.values.case_from === "Perdhaki" && (
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"Pilih SR"}
              name={"sr_id"}
              placeholder={"Pilih SR"}
              data={srData}
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                if (selectedValue) {
                  formik.handleChange("sr_id")(selectedValue);
                }
                if (!selectedValue) {
                  formik.setFieldValue("ssr_id", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={
                srData?.find((item) => item.value === formik.values.sr_id) || ""
              }
              error={formik.errors.sr_id && formik.touched.sr_id}
              errorMessage={formik.errors.sr_id}
              isRequired={true}
              disabled={isBKKUser && isEdit}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Pilih SSR"}
              name={"ssr_id"}
              placeholder={"Pilih SSR"}
              data={ssrData}
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                if (selectedValue) {
                  formik.handleChange("ssr_id")(selectedValue);
                }
              }}
              onBlur={formik.handleBlur}
              value={
                ssrData?.find((item) => item.value === formik.values.ssr_id) ||
                ""
              }
              error={formik.errors.ssr_id && formik.touched.ssr_id}
              errorMessage={formik.errors.ssr_id}
              isRequired={true}
              isDisabled={!formik.values.sr_id}
              disabled={isBKKUser && isEdit}
            />
          </div>
        </div>
      )}
      {formik.values.discovery_activities === "Survei Kontak" && (
        <>
          <InputDate
            label={"Tanggal Survei Kontak"}
            name={"survey_contact_date"}
            placeholder={"Pilih Tanggal Survei Kontak"}
            dateFormat={"YYYY-MM-DD"}
            onChange={(e) => {
              const selectedDate = moment(e).format("YYYY-MM-DD");
              formik.handleChange("survey_contact_date")(selectedDate);
              getSurveyContacts(selectedDate);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.survey_contact_date}
            error={
              formik.errors.survey_contact_date &&
              formik.touched.survey_contact_date
            }
            errorMessage={formik.errors.survey_contact_date}
            isRequired={true}
            disabled={isBKKUser && isEdit}
          />
          <InputSelect
            label={"Kasus pertama yang menjadi pemicu survei kontak"}
            name={"first_case_trigger_survey_contact"}
            placeholder={"Pilih Kasus Kontak"}
            data={surveyContactCases}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              if (selectedValue) {
                formik.handleChange("first_case_trigger_survey_contact")(
                  selectedValue,
                );
              }
            }}
            onBlur={formik.handleBlur}
            value={surveyContactCases?.find(
              (item) =>
                item.value === formik.values.first_case_trigger_survey_contact,
            )}
            disabled={isBKKUser && isEdit}
          />
        </>
      )}
      {formik.values.discovery_activities === "MBS" && (
        <InputSelect
          label={"Tanggal MBS"}
          name={"mbs_date"}
          placeholder={"Pilih Tanggal MBS"}
          data={mbsDates}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            if (selectedValue) {
              formik.handleChange("mbs_date")(selectedValue);
            }
          }}
          onBlur={formik.handleBlur}
          value={mbsDates?.find(
            (item) => item.value === formik.values.mbs_date,
          )}
          error={formik.errors.mbs_date && formik.touched.mbs_date}
          errorMessage={formik.errors.mbs_date}
          isRequired={true}
          disabled={isBKKUser && isEdit}
        />
      )}
      {/* Render Operator Field Based on Condition */}
      {renderOperatorFieldByCondition()}
      {formik.values.house_visit === "Kader" && (
        <InputSelect
          label={"Apakah Penemuan Kasus oleh Kader Endemis Tinggi?"}
          name={"isCadre"}
          placeholder={"Pilih"}
          data={YesAndNoOptions}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            if (selectedValue) {
              formik.handleChange("isCadre")(selectedValue);
            }
          }}
          onBlur={formik.handleBlur}
          value={YesAndNoOptions?.find(
            (item) => item.value === formik.values.isCadre,
          )}
          error={formik.errors.isCadre && formik.touched.isCadre}
          errorMessage={formik.errors.isCadre}
          isRequired={true}
          disabled={isBKKUser && isEdit}
        />
      )}
      {formik.values.isCadre === "Ya" && (
        <>
          <InputSelect
            label={"Nama Kader"}
            name={"cadres_id"}
            placeholder={"Pilih Kader"}
            data={cadresData}
            onChange={(selectedValue) => {
              formik.setFieldValue("cadres_id", selectedValue);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.cadres_id}
            error={formik.errors.cadres_id && formik.touched.cadres_id}
            errorMessage={formik.errors.cadres_id}
            isMultipleSelect={true}
            isRequired={true}
            disabled={isBKKUser && isEdit}
          />
          <div className="warning-message">
            <div className="message">
              Bila pilihan kader tidak ada isian daftar list-nya, maka terlebih
              dahulu mengisi data kader pada menu Monitoring Kader
            </div>
          </div>
        </>
      )}
      <InputSelect
        label={"Jenis Pemeriksaan"}
        name={"lab_checking_type"}
        placeholder={"Pilih Jenis Pemeriksaan"}
        data={LabCheckingOptions}
        onChange={(e) => {
          const selectedValue = e ? e.value : "";
          if (selectedValue) {
            formik.handleChange("lab_checking_type")(selectedValue);
            if (selectedValue === "Tanpa Pemeriksaan") {
              formik.setFieldValue("no_registrasi_pasien", "");
              formik.setFieldValue("slide_code", "");
              formik.setFieldValue("total_rdt", "");
              formik.setFieldValue("lab_checking_date", "");
              formik.setFieldValue("parasyte", []);
            }

            if (selectedValue === "Mikroskop") {
              formik.setFieldValue(
                "parasyte",
                formik.values.parasyte &&
                  formik.values.parasyte.filter((item) => item !== "P.Mix"),
              );
            }

            if (selectedValue === "RDT") {
              formik.setFieldValue("no_registrasi_pasien", "");
              formik.setFieldValue("slide_code", "");
            }
          }
        }}
        onBlur={formik.handleBlur}
        value={LabCheckingOptions?.find(
          (item) => item.value === formik.values.lab_checking_type,
        )}
        error={
          formik.errors.lab_checking_type && formik.touched.lab_checking_type
        }
        errorMessage={formik.errors.lab_checking_type}
        isRequired={true}
      />
      {formik.values.lab_checking_type !== "Tanpa Pemeriksaan" && (
        <InputField
          label={"Jumlah RDT yang digunakan"}
          name={"total_rdt"}
          type={"number"}
          placeholder={"Masukkan jumlah RDT yang digunakan"}
          {...formik.getFieldProps("total_rdt")}
          error={formik.errors.total_rdt && formik.touched.total_rdt}
          errorMessage={formik.errors.total_rdt}
          isRequired={true}
        />
      )}
      {formik.values.lab_checking_type === "Mikroskop" && (
        <InputField
          label={"Nomor Registrasi Pasien"}
          name={"no_registrasi_pasien"}
          placeholder={"Masukkan Nomor Registrasi"}
          maxLengthVal={20}
          type={"text"}
          {...formik.getFieldProps("no_registrasi_pasien")}
          error={
            formik.errors.no_registrasi_pasien &&
            formik.touched.no_registrasi_pasien
          }
          errorMessage={formik.errors.no_registrasi_pasien}
          isRequired={true}
          disabled={!isNotifikasiBKK && isBKKUser && isEdit}
        />
      )}
      <div className="row">
        <div className="col">
          <InputDate
            label={"Tanggal Kunjungan Pasien"}
            name={"patient_visite_date"}
            placeholder={"Pilih Tanggal"}
            dateFormat={"YYYY-MM-DD"}
            onChange={(e) => {
              const selectedDate = moment(e).format("YYYY-MM-DD");
              formik.handleChange("patient_visite_date")(selectedDate);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.patient_visite_date}
            error={
              formik.errors.patient_visite_date &&
              formik.touched.patient_visite_date
            }
            errorMessage={formik.errors.patient_visite_date}
            isRequired={true}
            isDisabled={isBKKUser && isEdit}
            isValidDate={(current) => current.isSameOrBefore(moment(), "day")}
          />
        </div>
        {formik.values.lab_checking_type !== "Tanpa Pemeriksaan" && (
          <div className="col">
            <InputDate
              label={"Tanggal Pemeriksaan Lab"}
              name={"lab_checking_date"}
              placeholder={"Pilih Tanggal"}
              dateFormat={"YYYY-MM-DD"}
              onChange={(e) => {
                const selectedDate = moment(e).format("YYYY-MM-DD");
                formik.handleChange("lab_checking_date")(selectedDate);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.lab_checking_date}
              error={
                formik.errors.lab_checking_date &&
                formik.touched.lab_checking_date
              }
              errorMessage={formik.errors.lab_checking_date}
              isRequired={true}
            />
          </div>
        )}
      </div>

      {formik.values.lab_checking_type === "Mikroskop" && (
        <>
          <InputField
            label={"Nomor urut slide"}
            name={"nomor_urut_slide"}
            placeholder={"Masukkan nomor urut slide"}
            {...formik.getFieldProps("nomor_urut_slide")}
            value={formik.values.nomor_urut_slide}
            onBlur={formik.handleBlur}
            error={
              formik.errors.nomor_urut_slide && formik.touched.nomor_urut_slide
            }
            errorMessage={formik.errors.nomor_urut_slide}
            isRequired={true}
            disabled={!isNotifikasiBKK && isBKKUser && isEdit}
          />
          <InputField
            label={"Kode slide"}
            name={"slide_code"}
            placeholder={"Kode Slide Otomatis"}
            value={formik.values.slide_code}
            disabled={true}
          />
        </>
      )}

      {(formik.values.lab_checking_type === "Mikroskop" ||
        formik.values.lab_checking_type === "RDT") && (
        <InputCheckbox
          label="Jenis Parasit"
          name="parasyte"
          options={[
            { label: "P.falciparum", value: "P.Falciparum" },
            { label: "P.malariae", value: "P.Malariae" },
            { label: "Probable knowlesi", value: "Probable Knowlesi" },
            { label: "P.vivax", value: "P.Vivax" },
            { label: "P.ovale", value: "P.Ovale" },
            ...(formik.values.lab_checking_type === "RDT"
              ? [{ label: "P.mix", value: "P.Mix" }]
              : []),
          ]}
          onChange={(e) => handleCheckboxChange(e)}
          onBlur={formik.handleBlur}
          selectedOption={formik.values.parasyte}
          isItalic={true}
          error={formik.errors.parasyte && formik.touched.parasyte}
          errorMessage={formik.errors.parasyte}
          isRequired={true}
        />
      )}
      <hr />
      <div className="form_action">
        <Button variant={"tertiary"} size={"normal"} onClick={onPrevStep}>
          Kembali
        </Button>
        <Button
          variant={"primary"}
          size={"normal"}
          onClick={onNextStep}
          isDisabled={isButtonDisabled()}
        >
          Selanjutnya
        </Button>
      </div>
    </>
  );
};

export default DiscoveryStatusStepForm;
